import Vue from 'vue'
import { Row, Col,Icon, Button, Cell, CellGroup, Field, RadioGroup, Radio, Notify, Lazyload,
    Search, DropdownMenu, DropdownItem, PullRefresh, Card, List,Pagination, Loading,Grid, GridItem,Image, Picker, Popup,Toast,Tab,Tabs,Panel,Dialog,Checkbox,CheckboxGroup,Empty,Form,Badge,Uploader } from 'vant'

Vue.use(Row)
Vue.use(Col)
Vue.use(Icon)
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Field)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Notify)
Vue.use(Lazyload)
Vue.use(Search)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(PullRefresh)
Vue.use(Card)
Vue.use(Pagination)
Vue.use(List)
Vue.use(Loading)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Image)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Toast)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Panel)
Vue.use(Dialog)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Empty)
Vue.use(Form)
Vue.use(Badge)
Vue.use(Uploader)
